import {saveAs} from 'file-saver';
import html2canvas from 'html2canvas';

import {analyticsClient} from '../../analytics-client';

export const downloadReport = (input: {
    chartSelector: string;
    trackingParams?: any;
    reportTitle: string;
}) => {
    const {chartSelector, trackingParams, reportTitle} = input;

    const chartNode = document.querySelector(chartSelector);

    if (chartNode) {
        analyticsClient.track(analyticsClient.EVENTS.TRACK_REPORT_CHART_DOWNLOAD, trackingParams);

        const leftPos = window.scrollX + chartNode.getBoundingClientRect().left;
        svgToCanvas(chartNode);
        // @ts-expect-error
        html2canvas(chartNode, {
            onclone(document) {
                const downloadHeaderNodes = document.querySelectorAll('.download-chart-header');
                if (downloadHeaderNodes) {
                    // @ts-expect-error
                    downloadHeaderNodes.forEach((node) => (node.style.display = 'block'));
                }

                const uiHeaderNodes = document.querySelectorAll('.report-chart-ui-header');
                if (uiHeaderNodes) {
                    // @ts-expect-error
                    uiHeaderNodes.forEach((node) => (node.style.display = 'none'));
                }
            },
            // Distance from the chart container to the left of the window. Changes if the filter drawer is open.
            x: leftPos,
            // Prevent odd grey background on non-retina screens
            scale: 2,
            ignoreElements: (node) => {
                try {
                    // We need to ignore FA icons because they use pseudo-elements which are not supported by html2canvas
                    if (node instanceof SVGElement && node.classList.contains('svg-inline--fa')) {
                        return true;
                    }
                } catch (_e: any) {
                    // Ignore
                }

                return false;
            },
        }).then((canvas) => {
            canvas.toBlob((blob) => {
                // @ts-expect-error
                saveAs(blob, reportTitle);
            });
        });
    }
};

/*
 * This helper function ensures that we get the correct fonts in the axes labels of the chart
 *
 * Taken from https://github.com/niklasvh/html2canvas/issues/1709#issuecomment-447798425
 */
// @ts-expect-error
function svgToCanvas(targetElem) {
    const svgElem = targetElem.getElementsByTagName('svg');
    for (const node of svgElem) {
        node.setAttribute(
            'font-family',
            window.getComputedStyle(node, null).getPropertyValue('font-family')
        );
        node.replaceWith(node);
    }
}
